<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-07-27 20:48:35
--> 
<template>
  <div>
    <staffLeave></staffLeave>
  </div>
</template> 
 
<script>
import staffLeave from './staffLeave'
export default {
  components: {
    staffLeave
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>